export {default} from './EventBarV2';
